import { FunctionUtil } from "../../storyV2/function/FunctionUtil";
import { FuncResponse, FuncResponseType, FunctionBase, } from "../../storyV2/function/FunctionBase";
import { JsonUtil } from "../../cutil/JsonUtil";
import { settings } from "../../kernel/Settings";
export class AddDataSourceFunction extends FunctionBase {
    // sendParams?: Record<string, any>;
    // query?: string;
    // fileUuid?: string;
    constructor(brainClient, authStore, meStore, headerService, messageCenter, topicService, webscoketService) {
        super(brainClient, authStore);
        this.brainClient = brainClient;
        this.authStore = authStore;
        this.meStore = meStore;
        this.headerService = headerService;
        this.messageCenter = messageCenter;
        this.topicService = topicService;
        this.webscoketService = webscoketService;
    }
    async run(input, identityInfo, variableList = [], page = 1, next = undefined, pagination = undefined, requestParams = {}) {
        const data = requestParams || {};
        data.query = data.query || input;
        const pubsub_topic = await this.topicService.generateTopic(identityInfo, "addDataSource");
        const fileUuid = data.fileUuid;
        delete data.fileUuid;
        const params = {
            data: data,
            pubsub_topic: pubsub_topic,
            uuid: fileUuid,
        };
        const hasCustomIndexersPermission = await this.meStore.hasCustomIndexersPermission();
        if (hasCustomIndexersPermission) {
            let resResponse = await Promise.race([
                this.askCustomDataSource(params, identityInfo),
                this.webscoketService.websocketDataSource(pubsub_topic, identityInfo),
            ]);
            return new FuncResponse(FuncResponseType.CUSTOM_API, resResponse);
        }
        const httpPromise = this.askDataSource(params, identityInfo);
        const websocketPromise = this.askWebsocketDataSource(pubsub_topic, identityInfo);
        const res = await Promise.race([httpPromise, websocketPromise])
            .then(resResponse => {
            return Promise.resolve(resResponse);
        })
            .catch(error => {
            return Promise.reject(error);
        });
        return new FuncResponse(FuncResponseType.TEXT, res);
    }
    async askCustomDataSource(params, identityInfo) {
        const data = JsonUtil.stringify(params);
        return new Promise((resolve, reject) => {
            this.brainClient.global
                .request(settings.API + "/be/vectordb/indexers/", "post", this.headerService.get(), data, FunctionUtil.createAbortUuid(identityInfo))
                .then(res => {
                if (res.status === 200 || res.status === 201) {
                    resolve(res);
                }
            });
        });
    }
    async askWebsocketDataSource(pubsub_topic, identityInfo) {
        return new Promise((resolve, reject) => {
            this.messageCenter.on(pubsub_topic, (res) => {
                const success = res.status === "succeed";
                const failed = res.status === "failed";
                if (success) {
                    this.messageCenter.off(pubsub_topic);
                    resolve(res.metadata.response);
                }
                else if (failed) {
                    const errorMsg = res.metadata.error ? res.metadata.error : res.status;
                    this.messageCenter.off(pubsub_topic);
                    reject({ message: errorMsg });
                }
            }, `${identityInfo?.projectId}_${identityInfo?.edgeId}`);
        });
    }
    async askDataSource(params, identityInfo) {
        return new Promise((resolve, reject) => {
            this.brainClient.user.searchInDataSource(params, FunctionUtil.createAbortUuid(identityInfo)).then(res => {
                if (res.status === 200 || res.status === 201) {
                    resolve(res.data);
                }
            });
        });
    }
}
